import type { ResolvedRunsSummaryTimeframe } from "./runsSummaryTypes"

export const TIMEFRAME_DAYS: Record<ResolvedRunsSummaryTimeframe, number> = {
  "24h": 1,
  "7d": 7,
  "30d": 30,
}

export const MIN_24H_RUNS = 10
export const MIN_30D_RUNS_FOR_DAILY_VIEW = 100
export const MIN_7D_RUNS = 3
export const MIN_30D_RUNS_FOR_WEEKLY_VIEW = 8
export const MIN_FINISHED_RUNS_FOR_TREND = 2
export const MIN_TREND_DELTA_POINTS = 5
export const MS_PER_DAY = 24 * 60 * 60 * 1000
export const MAX_SECTION_ITEMS = 3
export const MAX_INLINE_LIST_ITEMS = 3
export const MAX_SIGNAL_ITEMS = 6
export const MIN_SIGNIFICANT_METRIC_RELATIVE_DELTA = 0.15
export const MIN_SIGNIFICANT_METRIC_ABSOLUTE_DELTA = 0.1
export const MIN_HEADLINE_METRIC_MEASUREMENTS = 3
export const MIN_HEADLINE_METRIC_COVERAGE_SHARE = 0.1
export const MIN_COVERAGE_DISTRIBUTION_SHIFT = 0.2
export const MIN_ROWS_FOR_COVERAGE_CONCENTRATION = 5
export const TOP_AGENT_CONCENTRATION_SHARE = 0.35
export const TOP_TWO_AGENTS_CONCENTRATION_SHARE = 0.5
export const MIN_DOMINANT_NEW_COVERAGE_COUNT = 3
export const DOMINANT_NEW_COVERAGE_SHARE = 0.35
export const WHAT_CHANGED_SECTION_TITLE = "What Changed"
export const WORTH_DIGGING_SECTION_TITLE = "Worth Digging Into"
export const DATA_QUALITY_SECTION_TITLE = "Data Quality"
export const COVERAGE_SECTION_TITLE = "Coverage"
export const FOCUS_SECTION_TITLE = "Priority Focus"
export const AGENT_EVALUATION_SECTION_TITLE = "Agent Evaluation"
export const OPERATIONAL_CONTEXT_SECTION_TITLE = "Operational Context"
export const OPERATIONAL_CONTEXT_METRIC_MANAGERS = new Set([
  "audio_duration_metric_manager",
  "manager_latency",
  "manager_music_detection",
  "manager_persona_latency",
  "turn_count_metric_manager",
])
export const OPERATIONAL_CONTEXT_METRIC_IDENTIFIERS = new Set([
  "audioduration",
  "latency",
  "metrictypelatency",
  "musicdetection",
  "turncount",
])
export const NO_OBVIOUS_DIG_ITEM =
  "No obvious unsuccessful rows, thresholded metric concerns, or coverage changes in the available detail."
export const FOCUS_STOP_WORDS = new Set([
  "about",
  "agent",
  "agents",
  "and",
  "are",
  "care",
  "for",
  "from",
  "has",
  "have",
  "improve",
  "improving",
  "in",
  "into",
  "metric",
  "metrics",
  "on",
  "prioritize",
  "summary",
  "the",
  "this",
  "to",
  "trend",
  "trends",
  "watch",
  "with",
])
